var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-selector", class: { "has-warning": _vm.showWarning } },
    [
      _c(
        "div",
        {
          ref: "editorContainer",
          staticClass: "editor-container",
          on: { click: _vm.focusEditor },
        },
        [
          _c("editor-content", {
            staticClass: "mail-editor-content",
            attrs: { editor: _vm.editor },
            nativeOn: {
              paste: function ($event) {
                $event.preventDefault()
                return _vm.handlePaste.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDropdown
        ? _c(
            "div",
            { staticClass: "dropdown-container" },
            [
              _vm.loading
                ? _c("div", { staticClass: "loading-indicator" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("refresh"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Yükleniyor...")]),
                  ])
                : [
                    _vm.filteredOptions.length === 0
                      ? _c("div", { staticClass: "no-results" }, [
                          _vm._v(
                            "\n                Sonuç bulunamadı\n            "
                          ),
                        ])
                      : _vm._l(_vm.groupedOptions, function (group, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "option-group" },
                            [
                              group.label
                                ? _c("div", { staticClass: "group-label" }, [
                                    _vm._v(_vm._s(group.label)),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(group.options, function (option) {
                                return _c(
                                  "div",
                                  {
                                    key: option.value,
                                    staticClass: "option-item",
                                    class: {
                                      selected:
                                        _vm.selectedIndex ===
                                        _vm.getGlobalIndex(index, option),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectOption(option)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "option-content" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "option-label" },
                                          [_vm._v(_vm._s(option.label))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "option-mail" },
                                          [_vm._v(_vm._s(option.value))]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showWarning && _vm.selectedEmails.length > 1
        ? _c("div", { staticClass: "warning-message" }, [
            _c("i", { staticClass: "material-icons" }, [_vm._v("warning")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Girilen e-posta adreslerine tek tek gönderim yapılacaktır. Tek mail göndermek için CC ekleyiniz."
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }